import { Spinner } from 'react-bootstrap';

const ButtonSpinner = () => {
    return (
        <Spinner className='ms-1' animation="border" size="sm" />
    )
}

export default ButtonSpinner;